import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { useParams, Link } from "react-router-dom";
import Team from "../../api/team";
import Footer from "../../components/footer/Footer.js";
import cImg1 from "../../images/certificates/1.jpg";
import cImg2 from "../../images/certificates/2.jpg";
import cImg3 from "../../images/certificates/3.jpg";
import cImg4 from "../../images/certificates/4.jpg";

const TeamSinglePage = (props) => {
  const { slug } = useParams();

  const TeamDetails = Team.find((item) => item.slug === slug);

  return (
    <Fragment>
      <Navbar hclass={"wpo-header-style-2"} />
      <PageTitle pageTitle={TeamDetails.name} pagesub={TeamDetails.title} />
      <div className="team-pg-area section-padding">
        <div className="container">
          <div className="team-info-wrap">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="team-info-img">
                  <img src={TeamDetails.tImg} alt="" />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="team-info-text">
                  <h2>{TeamDetails.name}</h2>
                  <ul>
                    <li>
                      Papel: <span>Idealizadora Neurodesenvolver</span>
                    </li>
                    <li>
                      Área de Atuação:<span>{TeamDetails.title}</span>
                    </li>
                    <li>
                      Experiência:<span>12 Years</span>
                    </li>
                    <li>
                      Endereço:<span>Millington, Ave, TN 38053</span>
                    </li>
                    <li>
                      WhatsApp:
                      <span>
                        <Link to=""></Link>
                      </span>
                    </li>
                    <li>
                      Email:<span>youremail@gmail.com</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="exprience-area">
            <div className="row">
              <div className="col-lg-12">
                <div className="exprience-wrap">
                  <h2>Edy Rodrigues</h2>
                  <p>
                    Edy Rodrigues é uma profissional dedicada e apaixonada pelo
                    desenvolvimento infantil, com uma formação sólida e uma
                    trajetória marcada pelo compromisso em apoiar crianças,
                    adolescentes e suas famílias. Sua formação inclui Pedagogia,
                    Pós-graduação em Psicopedagogia Clínica, além de
                    especializações em Psicanálise e Terapia Familiar, o que lhe
                    permite integrar uma visão ampla e profunda do processo de
                    aprendizagem e desenvolvimento emocional.
                  </p>
                  <p>
                    Desde o início de sua carreira, Edy se interessou pela forma
                    como as emoções influenciam diretamente no aprendizado e, ao
                    longo dos anos, foi aprofundando seus estudos sobre o
                    impacto das dinâmicas familiares no desenvolvimento
                    cognitivo, emocional e comportamental das crianças. Seu
                    olhar atento para os desafios enfrentados por crianças em
                    situações de vulnerabilidade emocional e escolar a levou a
                    buscar uma formação mais especializada, incluindo um
                    Mestrado e Doutorado em Psicanálise Aplicada à Educação e
                    Saúde.
                  </p>
                  <p>
                    Durante seu estágio universitário, Edy percebeu que crianças
                    de lares disfuncionais enfrentavam grandes dificuldades, não
                    apenas emocionais, mas também no âmbito escolar. Isso
                    despertou nela o desejo de entender de maneira mais profunda
                    as interações entre a infância e o aprendizado, algo que se
                    tornaria a base para sua prática clínica e acadêmica.
                  </p>
                  <p>
                    Com experiência tanto em consultório quanto em cargos de
                    direção escolar, Edy tem se dedicado ao acompanhamento de
                    famílias e escolas, com especial foco em crianças e
                    adolescentes neuroatípicos, como aqueles com TDAH, dislexia,
                    TEA, dificuldades de aprendizagem e altas
                    habilidades/superdotação. Sua prática clínica e suas
                    pesquisas buscam sempre promover o bem-estar emocional e
                    cognitivo desses indivíduos, ajudando-os a superar desafios
                    e a maximizar seu potencial de forma saudável e inclusiva.
                  </p>
                  <p>
                    Além disso, Edy Rodrigues tem se destacado no
                    desenvolvimento de ferramentas psicoeducacionais validadas,
                    que visam auxiliar pais e educadores a implementarem
                    estratégias eficazes para apoiar o crescimento e a superação
                    das dificuldades de seus filhos e alunos.
                  </p>
                  <p>
                    Sua missão, através da Neurodesenvolver, é oferecer um olhar
                    humanizado, especializado e acolhedor para as famílias,
                    proporcionando não apenas soluções práticas, mas também o
                    apoio emocional necessário para transformar desafios em
                    oportunidades de aprendizado e crescimento.
                  </p>
                  <p>
                    Edy acredita firmemente que, ao trabalhar em conjunto com
                    pais e educadores, é possível ajudar as crianças a alcançar
                    seu pleno potencial e a viver uma vida mais equilibrada e
                    realizada.
                  </p>
                </div>
                <div className="education-area ex-wiget">
                  <h2>Formação</h2>
                  <ul>
                    <li>Pedagogia</li>
                    <li>Pós-graduação em Psicopedagogia Clínica</li>
                    <li>Pós-Graduação em Terapia da Familiar</li>
                    <li>
                      Doutorado em Psicanálise Aplicada à Educação e Saúde
                    </li>
                  </ul>
                </div>
                <div className="wpo-contact-area ex-wiget certificate">
                  <h2>Certificados</h2>
                  <div className="row">
                    <div className="col-lg-3 col-md-6 col-12">
                      <div className="certificate-img">
                        <div className="img-holder">
                          <img
                            src={cImg1}
                            alt=""
                            className="img img-responsive"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-12">
                      <div className="certificate-img">
                        <div className="img-holder">
                          <img
                            src={cImg2}
                            alt=""
                            className="img img-responsive"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-12">
                      <div className="certificate-img">
                        <div className="img-holder">
                          <img
                            src={cImg3}
                            alt=""
                            className="img img-responsive"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-12">
                      <div className="certificate-img">
                        <div className="img-holder">
                          <img
                            src={cImg4}
                            alt=""
                            className="img img-responsive"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer footerClass={"wpo-site-footer-s2"} />
      <Scrollbar />
    </Fragment>
  );
};
export default TeamSinglePage;
